import { FullScreenLayout } from 'ui/fullScreen/FullScreenLayout';

import { PreviewPane } from './PreviewPane';
import { DataPane } from '../../common/PreviewWithDataDataPane';
import { SettingsDrawer } from '../../common/SettingsDrawer';
import { EditorContentContainer, LayoutContentContainerFullWidth } from '../../common';
import { ViewFooter } from '../../common/ViewFooter';
import { ViewHeader } from '../../common/ViewHeader';
import { useTemplateQueryContext } from '../../context/TemplateQueryContext';
import { useEmbeddedPreviewContext } from '../context/EmbeddedPreviewContext';
import { PreviewContentContainer } from '../../common/PreviewContentContainer';
import { PreviewWithDataError } from '../../common/PreviewWithDataError';
import { PreviewWithErrorContainer } from '../../common/EditorContentContainer.styled';

export const TEMPLATE_EDITOR_EMBEDDED_PREVIEW_W_DATA = 'template-editor-embedded-preview-w-data';

export const PreviewWithDataCore = () => {
  const { onRefreshPreview, previewError } = useEmbeddedPreviewContext();

  return (
    <EditorContentContainer data-test={TEMPLATE_EDITOR_EMBEDDED_PREVIEW_W_DATA}>
      <DataPane onRefreshPreview={onRefreshPreview} />
      <PreviewWithErrorContainer>
        {previewError && <PreviewWithDataError previewError={previewError} />}
        <PreviewPane />
      </PreviewWithErrorContainer>
    </EditorContentContainer>
  );
};

export const PreviewWithData = () => {
  const { onRefreshPreview } = useEmbeddedPreviewContext();
  const { refetch } = useTemplateQueryContext();

  return (
    <FullScreenLayout
      actionBarIsAnchored
      DrawerContent={
        <SettingsDrawer
          onSaveSuccess={() => {
            onRefreshPreview();
            refetch();
          }}
        />
      }
      HeaderContent={<ViewHeader />}
      FooterContent={<ViewFooter />}
    >
      <PreviewContentContainer data-test="template-editor-embedded-preview">
        <LayoutContentContainerFullWidth>
          <PreviewWithDataCore />
        </LayoutContentContainerFullWidth>
      </PreviewContentContainer>
    </FullScreenLayout>
  );
};

export default PreviewWithData;
